import { useState, useEffect } from 'react';
import {
  ICVView,
  getCvViewByKeysAndUserEmail,
  ICandidate,
  ICvViewSearch,
  IJobCandidateInteraction,
} from 'wisestep-api';

export interface IKeys {
  [key: string]: string;
}

interface ICvViewsProps {
  cvViews: ICVView[];
  keys: string[];
}

const useCvViews = (
  query: IJobCandidateInteraction,
  candidates: ICandidate[],
  recruiterId: string
): ICvViewsProps => {
  const [state, setState] = useState<ICvViewsProps>({ cvViews: [], keys: [] });
  useEffect(() => {
    const fetchCandidates = async () => {
      const keys: string[] = [];
      candidates?.forEach((candidate) => {
        candidate.email && keys.push(candidate.email);
        candidate.linkedInURL && keys.push(candidate.linkedInURL);
      });
      const payload: ICvViewSearch = {
        keys: keys,
        recruiterId: recruiterId,
        jobCode: query.jobCode ?? '',
      };
      try {
        if (query) {
          const response = await getCvViewByKeysAndUserEmail(payload);
          const cvViewsData = response.data;
          setState({ cvViews: cvViewsData, keys: cvViewsData?.map(({ key }) => key) });
        }
      } catch (e) {
        console.log(e);
      }
    };
    if (
      (query.candidateSearchType == 'OnlyAppliedCandidates' ||
        query.source == 'AI_Suggestions_new') &&
      recruiterId?.length > 1 &&
      candidates.length > 0
    ) {
      fetchCandidates();
    }
  }, [candidates, query, recruiterId]);
  return state;
};

export default useCvViews;
